<template>
  <div class="shared-frame" :style="{height: computedHeight + 'px'}">
    <div class="shared-main" :style="{width: computedWidth - 30 + 'px', height: computedHeight + 'px'}">
      <div class="main-panel" :style="{width: computedWidth - 280 + 'px', height: computedHeight + 'px'}">
        <shared-list :filesList="sharedList" :fileShare="fileShare" @clickFileName="clickFileName" @getSharedList="getSharedList" @cancelShare="cancelShare"></shared-list>
      </div>
      <div class="right-panel">
        <div class="right-panel-box">
          <span class="right-span"><i class="el-icon-cus-user"></i>{{shareCreator}}</span>
          <span class="right-span">说明：{{shareComment}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ct from '../../utils/constant.js'
import sharedList from './SharedFiles.vue'
import { mapState } from 'vuex'
export default {
  created () {
    this.getSharedList()
  },
  data () {
    return {
      sharedList: [],
      fileShare: {},
      showOperateFlag: false,
      fontColor: '#303133',
      iconColor: 'gray'
    }
  },
  watch: {
    '$route.params.updateCode': function (val) {
      this.getSharedList()
    }
  },
  components: {
    sharedList
  },
  methods: {
    getSharedList () {
      let query = this.$route.query
      let sharedId = ''
      if (query) {
        sharedId = query.id
        let code = ''
        let params = this.$route.params
        if (params && params.passCode) {
          code = params.passCode
        }
        if (!sharedId) {
          return
        }
        // console.log('share')
        this.uploadFileRequest('share?id=' + sharedId + '&password=' + code, null).then(res => {
          if (res.data.code === 101) {
            this.$router.push({name: ct.RouterData.inputPassCode.name, query: {id: sharedId, flag: ct.UrlFlag.fromShare}})
          } else if (res.data.code === 0) {
            let result = res.data.result
            if (result) {
              this.fileShare = result.fileShare
              this.sharedList = this.initSharedList(result.files)
            }
          }
        })
      }
    },
    initSharedList (list) {
      let res = []
      list.forEach(file => {
        let obj = {}
        if (file.parentGuid) {
          obj.showOperateFlag = file.isDir === ct.Boolean.no
          obj.fontColor = this.fontColor
          obj.iconColor = this.iconColor
          obj.createDT = file.createDT
          obj.updateDT = file.updateDT
          let n = file.fileName
          obj.creator = file.creator
          obj.fileGuid = file.fileGuid
          obj.fileName = n
          obj.fileOwner = file.fileOwner
          obj.fileSource = file.fileSource
          obj.isDir = file.isDir
          obj.parentGuid = file.parentGuid
          obj.fileSize = this.getFileSize(file.fileSize)
          obj.fileDesc = file.fileDesc
          obj.category = file.category
          obj.operationStatus = file.operationStatus
          obj.presentationStatus = file.presentationStatus
          res.push(obj)
        }
      })
      return res
    },
    clickFileName (file) {
      if (!file) {
        return
      }
      let target = document.getElementById('app_content_file_table')
      let loading = this.$loading({text: '拼命加载中', target: target, spinner: 'el-icon-loading'})
      this.uploadFileRequest('shareFileList?parentGUID=' + file.fileGuid + '&shareGUID=' + this.fileShare.shareGUID + '&sortType=asc&orderColumn=' + ct.OrderColumn.updateDT, null).then(res => {
        this.sharedList = this.initSharedList(res.data.result)
        loading.close()
      })
    },
    cancelShare () { // 客户从我的分享页面进入
      this.$confirm('确认取消分享吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let row = this.fileShare
        this.postRequest('cancelSharingFiles', {shareGUIDs: [row.shareGUID]}).then(res => {
          if (res.data.code === 0) {
            this.$message({message: '取消成功～', type: 'success'})
            this.sharedList = []
          }
        })
      }).catch(() => {})
    }
  },
  computed: {
    ...mapState(['computedHeight', 'computedWidth']),
    shareCreator () {
      let c = this.fileShare.creator
      return c ? c.substring(0, 2) + '****' + c.substring(c.length - 3, c.length - 1) : ''
    },
    shareComment () {
      let c = this.fileShare.comment
      return c !== '' ? c : 'ta很懒，什么都没有说'
    }
  }
}
</script>
<style>
  .shared-frame {
    width:100%;
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FBFBFB;
  }

  .shared-main {
    display: flex;
    flex-direction: row;
    background-color: white;
    border-radius: 7px;
  }

  .right-panel {
    width: 250px;
    background-color: #EDF1F5;
    border-radius: 7px;
    min-width: 200px;
  }

  .right-panel-box {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    color: #6a7281;
    font-size: 15px;
  }

  .main-panel {
    min-width: 400px;
  }

  .right-span {
    padding: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/share/Shared.vue